import Grid, { GridViewColumn } from 'pf9-ui-components/built/elements/grid/Grid'
import React from 'react'
import { flavorsSelector } from 'app/plugins/openstack/components/flavors/selectors'
import { humanReadableSize } from 'app/plugins/openstack/helpers'
import { ArrayElement } from 'core/actions/Action'

type SelectorModel = ArrayElement<ReturnType<typeof flavorsSelector>>

const columns: GridViewColumn<SelectorModel>[] = [
  { key: 'name', label: 'Virtual Machine Flavor' },
  { key: 'vcpus', label: 'vCPUs' },
  {
    key: 'ram',
    label: 'Memory (Gb)',
    render: (ram) => humanReadableSize(ram * 1024 * 1024, false),
  },
  {
    key: 'disk',
    label: 'Storage (Gb)',
    render: (disk) => humanReadableSize(disk * 1024 * 1024 * 1024, false),
  },
]

export default function VirtualMachineFlavorsTable({ data, selectedItems = [], onChange }) {
  return (
    <Grid<SelectorModel>
      uniqueIdentifier="id"
      columns={columns}
      data={data}
      orderBy="vcpus"
      orderDirection="asc"
      emptyContent="No VM flavors available"
      disableRowSelection={false}
      multiSelection={false}
      selectedItems={selectedItems}
      onSelectChange={(value) => onChange(value)}
      disableToolbar
      hidePagination
    />
  )
}
